import { EmeraldDialogTypes } from 'src/common/enumerations/emerald-dialog-types';
import {
  getStoredValueReward,
  redeemStoredValueReward,
  RewardApprovalBody,
} from 'src/common/helpers/transaction-helper';
import { IMessageModal } from 'src/common/interfaces/dtos/IMessageModal';
import { store } from '../../common/redux/configure-store';
import { popupAsyncMessage, popupMessage } from '../../messages/business-logic/popup-message';
import { find } from 'lodash';
import { withSpinner } from 'src/common/components/with-spinner/with-spinner';

export const msvVoidCheck = async (): Promise<void> => {
  // Check if there's a loytaly user on the transaction
  const loyaltyUser = store.getState().transaction.transactionCustomer;
  if (loyaltyUser) {
    // Call to see if we have any redeemed MSV rewards
    const msvCheck = await getStoredValueReward().catch(() => {}); //do nothing else, even if get request throws error
    if (!!msvCheck && msvCheck.totalResults > 0) {
      const msvToCancel: any = find(msvCheck.pageContent, { redeemLoyalty: { approved: true } });
      // If we do, we need to cancel them in order to save the transaction
      if (msvToCancel) {
        const rewardRequest: RewardApprovalBody = {
          approved: false,
          promotionId: msvToCancel.redeemLoyalty.promotionId,
          programId: msvToCancel.redeemLoyalty?.programId,
        };
        await withSpinner(async () => {
          await redeemStoredValueReward(rewardRequest)
            .then(async () => {
              const modalProps: IMessageModal = {
                message: 'RewardsNotApplied',
                type: EmeraldDialogTypes.Info,
                hideCancelButton: true,
                subMessage: 'MSVSaveTransaction',
              };
              await popupAsyncMessage(modalProps);
            })
            .catch(err => {
              popupMessage(err);
            });
        });
      }
    }
  }
};
